/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { AddProjectParameterComponent } from "../../components/add-project-parameter/add-project-parameter.component";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class AddNewProjectParameterDialog implements PopupDialog {

    create(sysquePopupConfig: SysquePopupConfig): any {
        sysquePopupConfig.component = AddProjectParameterComponent;
        sysquePopupConfig.data = null;
        sysquePopupConfig.width = 620;
        sysquePopupConfig.height = 610;
        sysquePopupConfig.componentTitle = "Add Project Parameter";
    }
}
